import { useRef, type ReactElement } from 'react';
import { AgGrid } from '@common';
import styles from '../style.module.less';
import { ImporterService } from '../service';
import type { ConfirmProps } from '../types';

export function Confirm(props: ConfirmProps): ReactElement | null {
  const { current: service } = useRef(new ImporterService());

  if (props.step !== 2) {
    return null;
  }

  return (
    <div className={styles.stepContent}>
      <AgGrid
        height={300}
        pagination={false}
        paginationPageSize={Number.MAX_SAFE_INTEGER}
        columns={service.parseTitle(props.definitions)}
        data={props.data}
        defaultColDef={{
          filter: false,
          editable: false,
          suppressHeaderMenuButton: true,
          suppressHeaderFilterButton: true
        }}
      />
    </div>
  );
}
